// components/NavLink.tsx
import Link from "next/link";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-brands-svg-icons";

interface NavButtonProps {
  url: string;
  text: string;
  ariaLabel?: string;
  icon?: IconDefinition;
}

export default function NavButton({
  url,
  text,
  ariaLabel,
  icon,
}: NavButtonProps) {
  return (
    <Link
      href={url}
      className="flex items-center gap-2 px-5 py-2 bg-white text-background-grey rounded-sm hover:bg-primary-yellow self-start transition-colors"
      aria-label={ariaLabel}
    >
      <span>{text}</span>
      {icon != null ? <FontAwesomeIcon icon={icon} /> : <></>}
    </Link>
  );
}
